import { ThemeConfig, theme } from 'antd';

export const RevenueMarketFontFamily =
  '"Pretendard Variable", Pretendard, "Malgun gothic", "맑은 고딕", -apple-system, BlinkMacSystemFont, helvetica, "apple SD Gothic Neo", sans-serif';

export const CDS_ZINDEX = {
  DRAWER: {
    BASE: 1010,
  },
  BOTTOM_SHEET: {
    BASE: 1010,
  },
  DROP_DOWN: {
    BASE: 100,
  },
  FLOATING_BUTTON: 2,
  STICKY: 3,
  POP_UP: 1010,
  CASH_FLOW_HEADER: 1002,
  MOBILE: {
    HEADER: 1000,
  },
} as const;

export const themeForClobe: ThemeConfig = {
  algorithm: [theme.compactAlgorithm],
  token: {
    colorInfo: '#19B9B1',
    colorPrimary: '#19B9B1',
    colorSuccess: '#29BD72',
    fontFamily: RevenueMarketFontFamily,
    zIndexPopupBase: CDS_ZINDEX.POP_UP,
    fontSizeIcon: 12,
  },
};
